<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="myExtraLargeModalLabel">
      <ng-container>
        Merchant registration
      </ng-container>
    </h4>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body">

    <form [formGroup]="MerchantRegistrationGroup" role="form" autocomplete="off">

      <div class="row form-horizontal">
        <div class="col-md-12 form-horizontal px-3">

          <div class="form-group">
            <br />
            <b style="color: orange;"> Merchant registration</b>
            <div class="fc-divider dropdown-divider" style="border:1px solid teal"></div>
            <br />
          </div>

          <div *ngIf="!!raiseErrors">
            <ngb-alert type="danger" [dismissible]="false" style="width:100%">
              <strong>Error!</strong> {{errorMessage}}
            </ngb-alert>
          </div>

          <div class="form-group row">
            <label for="merchantNumber" class="col-4 col-form-label">Merchant Number</label>
            <div class="col-8">
              <input formControlName="merchantNumber" class="form-control" id="merchantNumber" placeholder="Merchant Number" maxlength="15">
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="MerchantRegistrationGroup.controls['merchantNumber'].hasError('required')" class="parsley-required">Merchant number is required.</li>
                <li *ngIf="MerchantRegistrationGroup.controls['merchantNumber'].hasError('minlength')" class="parsley-error">Merchant number must be atleast 15 characters.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label for="merchantNumber" class="col-4 col-form-label">Shop name</label>
            <div class="col-8">
              <input formControlName="shopName" class="form-control" id="shopName" placeholder="Shop name" maxlength="23">
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="MerchantRegistrationGroup.controls['shopName'].hasError('required')" class="parsley-required">Shop name is required.</li>
                <li *ngIf="MerchantRegistrationGroup.controls['shopName'].hasError('minlength')" class="parsley-error">Shop name must be atleast 23 characters.</li>
              </ul>
            </div>
          </div>


          <div class="form-group row">
            <div class="col-12">
              <button type="button"
                      class="btn btn-info waves-effect waves-light fa-pull-right"
                      (click)="save()">
                Save & Close
              </button>
            </div>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>
